import React, { useState } from "react";
import "../styles/AuthPage.css";
import AuthForm from "../components/AuthForm";

const AuthPage = ({ onLogin }) => {
  const [isLogin, setIsLogin] = useState(true);
  const [isForgot, setIsForgot] = useState(false);

  return (
    <div className="auth-shell">
      <div className="auth-shell__panel auth-shell__panel--brand">
        <div className="auth-brand">
          <span className="auth-brand__badge">IG</span>
          <h1 className="auth-brand__title">IntelliGrocer</h1>
          <p className="auth-brand__subtitle">Grocery workflows for shoppers, employees, and store managers.</p>
          <div className="auth-brand__highlights">
            <article>
              <span>Shopper</span>
              <strong>Browse products, build a basket, and place orders.</strong>
            </article>
            <article>
              <span>Employee</span>
              <strong>Track tasks, view schedules, and work department inventory.</strong>
            </article>
            <article>
              <span>Manager</span>
              <strong>Monitor operations, assign work, and manage inventory changes.</strong>
            </article>
          </div>
        </div>
      </div>

      <div className="auth-shell__panel auth-shell__panel--form">
        <div className="auth-card">
          <div className="auth-card__header">
            <p className="auth-card__eyebrow">{isForgot ? "Password reset" : isLogin ? "Welcome back" : "Create account"}</p>
            <h2>{isForgot ? "Reset access" : isLogin ? "Sign in to IntelliGrocer" : "Start a new IntelliGrocer account"}</h2>
            <p className="auth-card__description">
              {isForgot
                ? "Enter the email you use for IntelliGrocer and we will guide you from there."
                : isLogin
                  ? "Use your saved account to continue where you left off."
                  : "Set up a demo account to explore shopper, employee, or manager flows."}
            </p>
          </div>

        {isForgot ? (
          <>
            <form className="auth-card__form">
              <input className="auth-card__input" type="email" placeholder="Enter your email" required />
              <button className="auth-card__submit" type="submit">Reset Password</button>
            </form>
            <p onClick={() => setIsForgot(false)} className="auth-card__link">
              Back to sign in
            </p>
          </>
        ) : (
          <>
            <AuthForm
              isLogin={isLogin}
              setIsLogin={setIsLogin}
              onLogin={onLogin}
            />
            <div className="auth-card__footer">
              <p onClick={() => setIsLogin(!isLogin)} className="auth-card__link">
                {isLogin ? "Don't have an account? Create one" : "Already have an account? Sign in"}
              </p>
              {isLogin && (
                <p onClick={() => setIsForgot(true)} className="auth-card__link">
                  Forgot Password?
                </p>
              )}
            </div>
          </>
        )}
      </div>
      </div>
    </div>
  );
};

export default AuthPage;
